import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableSkeleton from "../../common-components/TableSkeleton";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { BodyBuilder, NoPic } from "../../../exports/Images";
import { stringToColor } from "../../../data/Constants";
import {
  CheckCircleIcon,
  CheckIcon,
  EyeIcon,
  ReceptionistIcon,
  TrainerIcon,
  XCircleIcon,
} from "../../../images/icons/icons";
import {
  convertStraight,
  convertTo12HourFormat,
  formatDateTime,
} from "../../common-data/Converts";

const RegularizationRequests = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
}) => {
  const {
    regularizationRequest,
    regularizationRequestError,
    regularizationRequestLoading,
  } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (
      !regularizationRequestLoading &&
      !regularizationRequestError &&
      regularizationRequest?.status &&
      regularizationRequest?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: regularizationRequest.data,
        pagination:
          regularizationRequest?.pagination?.length > 0
            ? regularizationRequest.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    regularizationRequestLoading,
    regularizationRequestError,
    regularizationRequest,
  ]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "Staff",
      formatter: (_, row) => (
        <>
          <div className="emeberDetailsRowContainer">
            {row?.profile ? (
              <img
                src={row?.profile || BodyBuilder}
                alt={row?.user_name || "N/A"}
                className="image"
                onClick={() =>
                  row?.profile &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "image_view",
                    image: row?.profile,
                    rowData: row,
                  }))
                }
              />
            ) : (
              <div
                className="nameInitials"
                style={{ backgroundColor: stringToColor(row?.user_name || "") }}
              >
                <span className="nameLetters">
                  <span className="nameLetters">
                    {row?.user_name
                      ?.split(" ")
                      .map((namePart, index) =>
                        index === 0 ||
                        index === row?.user_name?.split(" ").length - 1
                          ? namePart.charAt(0).toUpperCase()
                          : null
                      )}
                  </span>
                </span>
              </div>
            )}
            <span className="tb-data text-start">
              {row?.user_name || "NA"}
              <br />
              {(row?.user_mobile || row?.user_email) && (
                <small className="lowercase">
                  {row?.user_mobile || ""}
                  <br />
                  {row?.user_email || ""}
                </small>
              )}
            </span>
          </div>

          <br />

          <span
            className="tb-data withIcon minWidth100 withPadding borderRdius64px"
            style={{
              backgroundColor:
                row?.user_account_type === "receptionist"
                  ? "#EBE8FE"
                  : "#FEF0E8",
              color: "#0C0B0B",
            }}
          >
            <div className="icon">
              {row?.user_account_type === "receptionist" ? (
                <ReceptionistIcon />
              ) : (
                <TrainerIcon />
              )}
            </div>
            <span className="label">
              {row?.user_account_type === "receptionist"
                ? "Sales Executives"
                : row?.user_account_type?.replace(/_/g, " ")}
            </span>
          </span>
        </>
      ),
    },
    {
      dataField: "date",
      text: "date of regularization request",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {convertStraight(row?.date || "-")}
          </span>
        );
      },
    },
    {
      dataField: "checkin_time",
      text: "checkin time",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth90">{row?.checkin_time || "-"}</span>
        );
      },
    },
    {
      dataField: "checkout_time",
      text: "checkout time",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.checkout_time || "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkin_proof",
      text: "checkin proof",
      formatter: (_, row) => {
        return (
          <div className="flexCenter">
            <div className="tb-data-img">
              <img
                src={row?.checkin_proof || NoPic}
                alt={row?.user_name || "NA"}
                className="image"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "checkin-proof",
                    image: row?.checkin_proof || NoPic,
                    rowData: row,
                  }));
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      dataField: "manager_id",
      text: "manager approval",
      formatter: (_, row) => {
        const isAppoved = row?.manager_id;
        const isManagerRejected = row?.status === "rejected" && !row?.hr_id;
        const isEnabled = isAdmin || isClusterManager;

        return (
          <span className="tb-data text-center icon">
            {isManagerRejected ? (
              <XCircleIcon />
            ) : isAppoved ? (
              <CheckIcon color="#328300" />
            ) : (
              <button
                type="button"
                className="actionBtn"
                style={{
                  background: row?.isAppoved ? "#328300" : "#000",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "15px",
                  padding: "10px",
                  textTransform: "capitalize",
                  opacity: isEnabled ? "1" : "0.5",
                  cursor: isEnabled ? "pointer" : "not-allowed",
                }}
                disabled={!isEnabled}
                onClick={() => {
                  isEnabled &&
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "manager_approve",
                      rowData: row,
                    }));
                }}
              >
                {row?.isAppoved ? "completed" : "approve"}
              </button>
            )}
          </span>
        );
      },
    },
    {
      dataField: "hr_id",
      text: "HR Approval",
      formatter: (_, row) => {
        const isAppoved = row?.hr_id && row?.manager_id;
        const isHRRejected = row?.status === "rejected" && row?.hr_id;
        const isEnabled =
          isAdmin &&
          row?.manager_id &&
          row?.status !== "approved" &&
          row?.status !== "rejected";

        return (
          <span className="tb-data text-center icon minWidth100">
            {isHRRejected ? (
              <XCircleIcon />
            ) : isAppoved ? (
              <CheckIcon color="#328300" />
            ) : (
              <button
                type="button"
                className="actionBtn"
                style={{
                  background: "#2973B2",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "15px",
                  padding: "10px",
                  textTransform: "capitalize",
                  opacity: isEnabled ? 1 : 0.5,
                  cursor: isEnabled ? "pointer" : "not-allowed",
                }}
                disabled={!isEnabled}
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "hr_approve",
                    rowData: row,
                  }));
                }}
              >
                approve
              </button>
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_different_gym",
      text: "different gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_different_gym ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "reason",
      text: "remarks",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.reason ? "link" : ""}`}
            onClick={() => {
              row?.reason &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "remarks",
                  rowData: row,
                }));
            }}
          >
            {row?.reason ? "read" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "Shift timing",
      formatter: (_, row) => {
        return (
          <>
            {row.shift_details &&
            Array.isArray(row.shift_details) &&
            row.shift_details.length > 0 ? (
              row.shift_details.map((shift, index) => (
                <p className="tb-data minWidth150" key={index}>
                  {convertTo12HourFormat(shift.start_time)} -{" "}
                  {convertTo12HourFormat(shift.end_time)}{" "}
                </p>
              ))
            ) : (
              <span className="tb-data">No Shift found</span>
            )}
          </>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <p className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </p>
        );
      },
    },
    {
      dataField: "details",
      text: "view details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <EyeIcon />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mb30">
      {regularizationRequestLoading ? (
        <TableSkeleton
          coloumns={tbColumns.length}
          rows={allDatas.allData.length || 10}
        />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default RegularizationRequests;
